
import { createPassword } from "@/api/authentication"
export default {
  data() {
    return {
      password: "",
      confirmPassword: "",
      passwordLengthValid: false,
      passwordContainsNumber: false,
      clickedSubmit: false
    }
  },
  methods: {
    validatePassword() {
      if (this.password.length >= 6 && this.password.length <= 16) {
        this.passwordLengthValid = true
      } else {
        this.passwordLengthValid = false
      }

      if (/\d/.test(this.password)) {
        this.passwordContainsNumber = true
      } else {
        this.passwordContainsNumber = false
      }
    },
    async submitPassword() {
      this.validatePassword()
      this.clickedSubmit = true
      if (this.password === this.confirmPassword && this.passwordLengthValid && this.passwordContainsNumber) {
        await createPassword({
          password: this.password,
          loginChannel: 3
        })
      }
    },
    handleClickCancel() {
      this.$router.push({
        path: "/"
      })
    }
  }
}
